import React from "react"
import { Link } from "gatsby"

export default function Paginator({ pagesCount, currentPage, url }) {
  const items = []

  for (let i = 1; i <= pagesCount; i++) {
    items.push(i)
  }

  return (
    <div className="pagination">
      <ul>
        {url && <li key={0} className={currentPage === 1 ? "disabled" : "page-item"}>
          <Link className="page-link" to={"/" + url + "/1"}>
            «
          </Link>
        </li>}

        {items.map(item => {
          return (
            url ? <li
            key={item}
            className={"page-item" + (currentPage === item ? " active" : "")}
          >
            <Link className="page-link" to={"/" + url + "/" + item}>
              {item}
            </Link>
          </li> : <></>
          )
        })}

        {url && <li
          key={pagesCount + 1}
          className={currentPage === pagesCount ? "disabled" : "page-item"}
        >
          <Link className="page-link" to={"/" + url + "/" + pagesCount}>
            »
          </Link>
        </li>}
      </ul>
    </div>
  )
}
